"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSendBoxSpeechInterimsVisible = useSendBoxSpeechInterimsVisible;
exports.default = void 0;

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _DictationInterims = _interopRequireDefault(require("./SendBox/DictationInterims"));

var _MicrophoneButton = _interopRequireDefault(require("./SendBox/MicrophoneButton"));

var _SendButton = _interopRequireDefault(require("./SendBox/SendButton"));

var _SuggestedActions = _interopRequireDefault(require("./SendBox/SuggestedActions"));

var _TextBox = _interopRequireDefault(require("./SendBox/TextBox"));

var _UploadButton = _interopRequireDefault(require("./SendBox/UploadButton"));

var _useActivities3 = _interopRequireDefault(require("./hooks/useActivities"));

var _useDirection3 = _interopRequireDefault(require("./hooks/useDirection"));

var _useDictateState3 = _interopRequireDefault(require("./hooks/useDictateState"));

var _useStyleOptions3 = _interopRequireDefault(require("./hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("./hooks/useStyleSet"));

var _useWebSpeechPonyfill4 = _interopRequireDefault(require("./hooks/useWebSpeechPonyfill"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var _Constants$DictateSta = _botframeworkWebchatCore.Constants.DictateState,
    DICTATING = _Constants$DictateSta.DICTATING,
    STARTING = _Constants$DictateSta.STARTING;
var ROOT_CSS = (0, _glamor.css)({
  '& > .main': {
    display: 'flex'
  }
});
var DICTATION_INTERIMS_CSS = (0, _glamor.css)({
  flex: 10000
});
var MICROPHONE_BUTTON_CSS = (0, _glamor.css)({
  flex: 1
});
var TEXT_BOX_CSS = (0, _glamor.css)({
  flex: 10000
}); // TODO: [P3] We should consider exposing core/src/definitions and use it instead

function activityIsSpeakingOrQueuedToSpeak(_ref) {
  var _ref$channelData = _ref.channelData;
  _ref$channelData = _ref$channelData === void 0 ? {} : _ref$channelData;
  var speak = _ref$channelData.speak;
  return !!speak;
}

function useSendBoxSpeechInterimsVisible() {
  var _useActivities = (0, _useActivities3.default)(),
      _useActivities2 = _slicedToArray(_useActivities, 1),
      activities = _useActivities2[0];

  var _useDictateState = (0, _useDictateState3.default)(),
      _useDictateState2 = _slicedToArray(_useDictateState, 1),
      dictateState = _useDictateState2[0];

  return [(dictateState === STARTING || dictateState === DICTATING) && !activities.filter(activityIsSpeakingOrQueuedToSpeak).length];
}

var BasicSendBox = function BasicSendBox(_ref2) {
  var className = _ref2.className;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      hideUploadButton = _useStyleOptions2[0].hideUploadButton;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      sendBoxStyleSet = _useStyleSet2[0].sendBox;

  var _useWebSpeechPonyfill = (0, _useWebSpeechPonyfill4.default)(),
      _useWebSpeechPonyfill2 = _slicedToArray(_useWebSpeechPonyfill, 1),
      _useWebSpeechPonyfill3 = _useWebSpeechPonyfill2[0];

  _useWebSpeechPonyfill3 = _useWebSpeechPonyfill3 === void 0 ? {} : _useWebSpeechPonyfill3;
  var SpeechRecognition = _useWebSpeechPonyfill3.SpeechRecognition;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var _useSendBoxSpeechInte = useSendBoxSpeechInterimsVisible(),
      _useSendBoxSpeechInte2 = _slicedToArray(_useSendBoxSpeechInte, 1),
      speechInterimsVisible = _useSendBoxSpeechInte2[0];

  var supportSpeechRecognition = !!SpeechRecognition;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(sendBoxStyleSet + '', ROOT_CSS + '', className + ''),
    dir: direction,
    role: "form"
  }, _react.default.createElement(_SuggestedActions.default, null), _react.default.createElement("div", {
    className: "main"
  }, !hideUploadButton && _react.default.createElement(_UploadButton.default, null), speechInterimsVisible ? _react.default.createElement(_DictationInterims.default, {
    className: DICTATION_INTERIMS_CSS + ''
  }) : _react.default.createElement(_TextBox.default, {
    className: TEXT_BOX_CSS + ''
  }), _react.default.createElement("div", null, supportSpeechRecognition ? _react.default.createElement(_MicrophoneButton.default, {
    className: MICROPHONE_BUTTON_CSS + ''
  }) : _react.default.createElement(_SendButton.default, null))));
};

BasicSendBox.defaultProps = {
  className: ''
};
BasicSendBox.propTypes = {
  className: _propTypes.default.string
};
var _default = BasicSendBox;
exports.default = _default;